module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_07@2x-c8fd9810e8260aa822818dc6ad260394.jpg";